<template>
  <div :id="`${id}-container`" class="form-item">
    <div class="label" :class="{ 'sr-only': !showLabel, 'label--block': blockLabel }">
      <label :for="id" :data-qa="`${id}-label`">
        {{ title }}
        <span v-if="mandatory" class="label--mandatory">*</span>
      </label>
    </div>
    <slot name="info" />
    <slot />

    <slot name="postInfo" />
    <div
      v-if="errorMessage"
      :id="`${id}-error`"
      role="region"
      class="error-message"
      aria-live="polite"
    >
      <slot name="error" /> {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    blockLabel: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@include sr-only;

:deep() {
  .label {
    display: inline-block;

    label {
      font-weight: $font-weight-bold;
    }

    &--mandatory {
      color: $color-danger;
    }

    &--block {
      display: block;
      margin-bottom: 0.5rem;
    }
  }

  select,
  input[type='text'],
  input[type='email'] {
    width: 100%;
  }

  .value {
    margin-top: 0.2em;
  }

  .error-message {
    display: block;
    margin-top: 0.25em;
    color: $color-danger;
    font-size: 0.8em;
  }
}
</style>
